import React from "react";
import "./RegalInputComponents.scss"



const RegalInputComponents = ({ label, value, onChange, placeholder, required, error, errorText, disable, type = "text" }) => {


    return (
        <div className="RegalInputComponents-RegalDefault">
            <div className="input-label">
                {label}
                {required && <span className="input-req">* </span>}
            </div>
            <div className={`RegalInputComponents-RegalDefault-container ${error ? "error" : disable ? "disable" : ""}`}>
                <input
                    className="RegalInputComponents-RegalDefault-container-input"
                    value={value}
                    onChange={onChange}
                    type={type}
                    placeholder={placeholder}
                    disabled={disable ?? false}
                />
            </div>
            {
                errorText !== "" && < div className="input-error-text">
                    {errorText}
                </div>
            }
        </div >
    )
}
export default RegalInputComponents
